import 'css-chunksrc/client/pages/projectPage/documentsPage/reportsPage/exportButton/styles.scss';export default {
  "exportButton": "_exportButton_if5i1_1",
  "text": "_text_if5i1_18",
  "icon": "_icon_if5i1_22"
};